import axios from 'axios'
import { getDefaultStrDate, clone } from '@/util/libUtil.js'

const state = () => ({
	selectedDay: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
	selectMonth: null,
	estadisticaVentas: {
		tipoVentaCount: [],
		isLoading: false,
	},
	estadisticaAccionesComerciales: {
		accionesComerciales: [],
		isLoading: false
	},
	estadisticaAgendados: {
		agendados: [],
		isLoading: false
	},
	estadisticaConsecucion: {
		consecucion: [],
		isLoading: false
	},
	estadisticaRanking: {
		ranking: [],
		isLoading: false
	},
	paths: {
		agendadosPath: '/api/clientes/agendados/',
		tipoVentaCountPath: '/api/atenciones/stats/tipoVentaCount/',
		accionesComercialesPath: '/api/atenciones/stats/accionesComerciales/',
		consecucionCountPath: '/api/atenciones/stats/consecucionCount/',
		rankingComercialesPath: '/api/atenciones/stats/rankingComerciales/'
	}
})

const mutations = {
	estadisticaVentas: (state, val) => {
		state.estadisticaVentas = clone(val)
	},
	isLoadingEstadisticaVentas: (state, val) => {
		state.estadisticaVentas.isLoading = val
	},
	estadisticaAccionesComerciales: (state, val) => {
		state.estadisticaAccionesComerciales = clone(val)
	},
	isLoadingestadisticaAccionesComerciales: (state, val) => {
		state.estadisticaAccionesComerciales.isLoading = val
	},
	estadisticaAgendados: (state, val) => {
		state.estadisticaAgendados = clone(val)
	},
	isLoadingestadisticaAgendados: (state, val) => {
		state.estadisticaAgendados.isLoading = val
	},
	estadisticaConsecucion: (state, val) => {
		state.estadisticaConsecucion = clone(val)
	},
	isLoadingestadisticaConsecucion: (state, val) => {
		state.estadisticaConsecucion.isLoading = val
	},
	estadisticaRanking: (state, val) => {
		state.estadisticaRanking = clone(val)
	},
	isLoadingestadisticaRanking: (state, val) => {
		state.estadisticaRanking.isLoading = val
	},
	selectedDay: (state, val) => {
		state.selectedDay = val
	},
	selectMonth: (state, val) => {
		state.selectMonth = val
	}
}

const actions = {
	async fetchRanking({ state, commit, getters }) {
		let dateRange = []
		if (state.selectMonth) {
			var date = new Date(state.selectMonth)
			var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
			var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
			dateRange = [
				getDefaultStrDate(firstDay),
				getDefaultStrDate(lastDay)
			]
		}
		var date = state.selectMonth ? new Date(state.selectMonth) : new Date()
		var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
		var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
		try {
			const res = await axios.get(getters.getEndpointFromPath(state.paths.rankingComercialesPath), {
				params: {
					'updated_on[]': dateRange
				}
			})
			commit('estadisticaRanking', {
				ranking: res.data,
				isLoading: false,
			})
		} catch (error) {
			console.log(error)
		}
	},
	async fetchConsecucion({ state, commit, getters }) {
		var date = state.selectMonth ? new Date(state.selectMonth) : new Date()
		var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
		var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)

		try {
			const res = await axios.get(getters.getEndpointFromPath(state.paths.consecucionCountPath), {
				params: {
					'updated_on[]': [
						getDefaultStrDate(firstDay),
						getDefaultStrDate(lastDay)
					]
				}
			})
			commit('estadisticaConsecucion', {
				consecucion: res.data,
				isLoading: false,
			})
		} catch (error) {
			console.log(error)
		}
	},
	async fetchTipoVentaCount({ state, commit, getters }) {
		try {
			const res = await axios.get(getters.getEndpointFromPath(state.paths.tipoVentaCountPath), {
				params: {
					updated_on: state.selectedDay
				}
			})
			commit('estadisticaVentas', {
				tipoVentaCount: res.data,
				isLoading: false,
			})
		} catch (error) {
			console.log(error)
		}
	},
	async fetchEstadisticaAccionesComerciales({ state, commit, getters }) {
		try {
			const res = await axios.get(getters.getEndpointFromPath(state.paths.accionesComercialesPath), {
				params: {
					updated_on: state.selectedDay
				}
			})
			commit('estadisticaAccionesComerciales', {
				accionesComerciales: res.data,
				isLoading: false,
			})
		} catch (error) {
			console.log(error);
		}
	},
	async fetchAgendados({ commit, getters, state }) {
		const today = (new Date())
		let delta = (new Date())
		delta.setDate(today.getDate() + 3)
		const params = {
			range: [today.toISOString().substr(0, 10), delta.toISOString().substr(0, 10)]
		}
		const { data } = await axios.get(getters.getEndpointFromPath(state.paths.agendadosPath),
			{
				params: params
			})
		commit("estadisticaAgendados", {
			agendados: data,
			isLoading: false
		})
	},
	init({ dispatch }) {
		return Promise.all((() => {
			let actions = [
				dispatch('fetchTipoVentaCount'),
				dispatch('fetchEstadisticaAccionesComerciales'),
				dispatch('fetchAgendados')
			]

			return actions
		})())
	},
}

const getters = {
	getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
		rootState.general.host + endpoint
	),
}

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions
}